export const EDITOR_CONTENT_WIDTH_CSS_VAR = '--editor-table-content-width'
